import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ModelResponse } from '../../core/services/ModelResponse';
import { SupportTicketInformationModel } from '../models/SupportTicketInformationModel';
import { SupportTicketModel } from '../models/SupportTicketModel';

@Injectable()
export class SupportTicketService {

  constructor(public httpClient: HttpClient) { }

  getSupportTicketInformation(): Observable<ModelResponse<SupportTicketInformationModel>> {
    return this.httpClient.get<ModelResponse<SupportTicketInformationModel>>("/api/ConfigurationModule/SupportTicket/GetSupportTicketInformation");
  }

  reviseDraftMessageToUsers(key: string, message: string): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ConfigurationModule/SupportTicket/${key}/ReviseDraftMessageToUsers/`, { model: message['draftMessageToUsersDescription'] });
  }

  reviseSupportTicketEmail(key: string, email: string): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ConfigurationModule/SupportTicket/${key}/ReviseSupportTicketEmail/`, { model: email });
  }

  activateDraftMessageToUsers(): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/ConfigurationModule/SupportTicket/ActivateDraftMessageToUsers/`, '');
  }

  submitSupportTicket(model: SupportTicketModel): Observable<ModelResponse<SupportTicketModel>> {
    return this.httpClient.post<ModelResponse<SupportTicketModel>>(`/api/ConfigurationModule/SupportTicket/SubmitSupportTicket/`, { model: model });
  }
}



// WEBPACK FOOTER //
// ./src/app/security/services/SupportTicketService.ts